import React from 'react';
import Badge from '@atlaskit/badge';
export var ToolbarKeyboardShortcutHint = function ToolbarKeyboardShortcutHint(_ref) {
  var shortcut = _ref.shortcut;
  return /*#__PURE__*/React.createElement(Badge, null, shortcut);
};